import { render, staticRenderFns } from "./EditCallQueueModal.vue?vue&type=template&id=2cfa29c5&scoped=true&"
import script from "./EditCallQueueModal.vue?vue&type=script&lang=js&"
export * from "./EditCallQueueModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCallQueueModal.vue?vue&type=style&index=0&id=2cfa29c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa29c5",
  null
  
)

export default component.exports